"use client"

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

const shortcuts = [
  { label: "Delete image", key: "Del" },
  { label: "Deselect", key: "Esc" },
  { label: "Nudge 1px", key: "Arrows" },
  { label: "Nudge 10px", key: "Shift+Arrows" },
  { label: "Fit to page", key: "F" },
  { label: "Center H", key: "H" },
  { label: "Center V", key: "V" },
  { label: "Rotate 90\u00b0", key: "R" },
  { label: "Duplicate", key: "Ctrl+D" },
  { label: "Bring forward", key: "]" },
  { label: "Send backward", key: "[" },
  { label: "Undo", key: "Ctrl+Z" },
  { label: "Redo", key: "Ctrl+Y" },
  { label: "Toggle grid", key: "G" },
  { label: "Zoom in", key: "Ctrl+=" },
  { label: "Zoom out", key: "Ctrl+-" },
  { label: "Reset zoom", key: "Ctrl+0" },
  { label: "Select all", key: "Ctrl+A" },
]

interface KeyboardShortcutsDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function KeyboardShortcutsDialog({ open, onOpenChange }: KeyboardShortcutsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Keyboard Shortcuts</DialogTitle>
          <DialogDescription>
            Use these shortcuts to work faster with your images
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-x-8 gap-y-2 text-sm">
          {shortcuts.map((s) => (
            <div key={s.key} className="flex justify-between">
              <span className="text-muted-foreground">{s.label}</span>
              <kbd className="px-2 py-0.5 bg-muted rounded text-xs">{s.key}</kbd>
            </div>
          ))}
        </div>
        <p className="text-xs text-muted-foreground mt-4">
          Right-click on images for more options
        </p>
      </DialogContent>
    </Dialog>
  )
}
